<template></template>

<script>
export default {
    name: "FlashToast",
    props: ["type", "message_key", "delay"],
    methods: {
        showToast(delay = 1000) {
            if (this.delay) delay = this.delay;
            setTimeout(() => {
                switch (this.type) {
                    case "success":
                        this.$toasted.success(this.$t(this.message_key));
                        break;

                    case "error":
                        this.$toasted.error(this.$t(this.message_key));
                        break;

                    default:
                        this.$toasted.show(this.$t(this.message_key));
                        break;
                }
            }, delay);
        },
    },
    mounted() {
        this.showToast();
    },
};
</script>

<style>
</style>